import React, { useState, useEffect, useCallback } from "react";
import { Badge } from "react-bootstrap";

import axiosInstance from "../../../../../services/AxiosInstance";
import { SpinnerCitoPlus } from "jsx/components/CitoPlus/components/loadingLogo";
import { notifyError } from "jsx/components/CitoPlus/components/CitoPlusToastr";

import "../../../table/FilteringTable/filtering.css";

const DIAS_SEMANA = ["Lun", "Mar", "Mié", "Jue", "Vie", "Sáb", "Dom"];

const ZonaSocialCard = ({ zona }) => {
  const formatDiasOperacion = (dias) => {
    if (!dias || dias.length === 0) return "No disponible";
    if (dias.length === 7) return "Todos los días";
    if (JSON.stringify([...dias].sort()) === JSON.stringify([0, 1, 2, 3, 4]))
      return "Lun - Vie";
    return dias.map((d) => DIAS_SEMANA[d]).join(", ");
  };

  return (
    <div
      className="card position-relative overflow-hidden zona-social-card-vigilante"
      style={{ height: "180px", border: "none" }}
    >
      {zona.imagen_url ? (
        <img
          src={zona.imagen_url}
          alt={zona.nombre}
          className="position-absolute w-100 h-100 zona-social-card-img"
          style={{ objectFit: "cover", transition: "transform 0.3s ease" }}
        />
      ) : (
        <div
          className="position-absolute w-100 h-100"
          style={{
            background: "linear-gradient(135deg, #6c757d 0%, #495057 50%, #343a40 100%)",
          }}
        />
      )}

      <div
        className="position-absolute w-100 h-100"
        style={{
          background: "linear-gradient(to top, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.4) 50%, rgba(0,0,0,0.2) 100%)",
        }}
      />

      <div className="position-absolute w-100 h-100 d-flex flex-column justify-content-between p-3 text-white">
        <div className="d-flex justify-content-between align-items-start">
          <h6 className="mb-0 fw-bold" style={{ textShadow: "2px 2px 4px rgba(0,0,0,0.5)" }}>
            {zona.nombre}
          </h6>
          <Badge
            bg={zona.tipo_reserva === "hora" ? "info" : "primary"}
            pill
            className="ms-2"
          >
            {zona.tipo_reserva === "hora" ? "Por hora" : "Por día"}
          </Badge>
        </div>

        <div className="row g-2">
          <div className="col-6">
            <small className="d-flex align-items-center">
              <i className="fas fa-clock me-2"></i>
              {zona.horario_inicio} - {zona.horario_fin}
            </small>
          </div>
          <div className="col-6">
            <small className="d-flex align-items-center">
              <i className="fas fa-calendar me-2"></i>
              {formatDiasOperacion(zona.dias_operacion)}
            </small>
          </div>
          <div className="col-6">
            <small className="d-flex align-items-center">
              <i className="fas fa-users me-2"></i>
              {zona.capacidad_min} - {zona.capacidad_max} personas
            </small>
          </div>
          {zona.tiempo_maximo_reserva && zona.tipo_reserva === "hora" && (
            <div className="col-6">
              <small className="d-flex align-items-center">
                <i className="fas fa-hourglass-half me-2"></i>
                Máx. {zona.tiempo_maximo_reserva}h
              </small>
            </div>
          )}
        </div>

        {zona.reglas_uso && (
          <div className="mt-1">
            <small
              className="text-truncate d-block"
              style={{ maxWidth: "100%", textShadow: "1px 1px 2px rgba(0,0,0,0.5)" }}
            >
              <i className="fas fa-info-circle me-1"></i>
              {zona.reglas_uso.replace(/<[^>]*>/g, "").substring(0, 60)}
              {zona.reglas_uso.length > 60 ? "..." : ""}
            </small>
          </div>
        )}
      </div>
    </div>
  );
};

const ZonasSocialesVigilante = () => {
  const [loading, setLoading] = useState(true);
  const [zonas, setZonas] = useState([]);

  const fetchZonas = useCallback(async () => {
    setLoading(true);
    try {
      const response = await axiosInstance.get("/api/v3/vigilancia/zonas-sociales/");
      setZonas(response.data.results || response.data);
    } catch (error) {
      console.error("Error fetching zonas:", error);
      notifyError("Error al cargar las zonas sociales");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchZonas();
  }, [fetchZonas]);

  if (loading) {
    return (
      <div className="text-center py-5">
        <SpinnerCitoPlus text="Cargando zonas sociales..." />
      </div>
    );
  }

  if (zonas.length === 0) {
    return (
      <div className="card">
        <div className="card-body text-center py-5">
          <i className="fas fa-building fa-3x text-muted mb-3"></i>
          <h5>No hay zonas sociales</h5>
          <p className="text-muted">No hay zonas sociales configuradas.</p>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="d-flex align-items-center mb-4 flex-wrap">
        <h4 className="fs-20 font-w600 me-auto">Zonas Sociales</h4>
      </div>

      <style>{`
        .zona-social-card-vigilante:hover .zona-social-card-img {
          transform: scale(1.05);
        }
        .zona-social-card-vigilante:hover {
          box-shadow: 0 0.5rem 1.5rem rgba(0, 0, 0, 0.2);
        }
      `}</style>

      <div className="row g-3">
        {zonas.map((zona) => (
          <div key={zona.uuid} className="col-md-6 col-lg-4">
            <ZonaSocialCard zona={zona} />
          </div>
        ))}
      </div>
    </>
  );
};

export default ZonasSocialesVigilante;
